/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

export default function useScroll() {
  const ref = useRef<any>(null);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!ref.current) return;
      if (ref.current.scrollHeight - Math.abs(ref.current.scrollTop) === ref.current.clientHeight)
        ref.current.scrollTo({ top: 0, behavior: 'auto' });
      ref.current.scroll({ top: ref.current.scrollTop + 1, behavior: 'smooth' });
    }, 100);
    return () => clearInterval(interval);
  }, []);
  return ref;
}
